(function ($) {
  'use strict';
  var fetchPosts = require('./fetchPosts');
  var block_external_links = require('./outgoinglinks.js');

  var $search_form = $('#search-publications');

  if($search_form.length > 0){
    $(document.body).on('submit', '#search-publications',function (ev) {
      ev.preventDefault();
      // check of the search field is not empty
      var $search_input1 = $('#search_term1');
      var $search_input2 = $('#search_term2');
      var search_term1 = $search_input1.val();
      var search_term2 = $search_input2.val();
      var errors = false;

      $('form p.error').remove();
      if(search_term1 === null || search_term1 === '' || search_term2 === null || search_term2 === ''){

        if(search_term1 === null || search_term1 === '') {
            errors = true;
            $search_input1.addClass('error');
            $search_input1.parent().after('<p class="error">Vul het zoekveld a.u.b. in.</p>');
        }
        if(search_term2 === null || search_term2 === '') {
            errors = true;
            $search_input2.addClass('error');
            $search_input2.parent().after('<p class="error">Vul het zoekveld a.u.b. in.</p>');
        }
    } else {
        if(search_term1 == search_term2) {
            errors = true;
            $search_input2.addClass('error');
            $search_input2.parent().after('<p class="error">Vul 2 verschillende zoektermen in a.u.b.</p>');
        }
    }

      if(errors) {
          return false;
      } else {
        $search_input1.parent().removeClass('error');
        $search_input2.parent().removeClass('error');
        $('form p.error').remove();
        $('.publications-search-results').html('De zoekopdracht wordt uitgevoerd...');

        var input_terms1 = search_term1.replace(/,/g , '').replace(' ' , '-');
        var input_terms2 = search_term2.replace(/,/g , '').replace(' ' , '-');

        var ajax_data = {
          action: 'search_publications',
          post_type: $('#post-type').val(),
          search_term1: input_terms1,
          search_term2: input_terms2
        };

        //$('#search-publications .loader').remove();

        // do a ajax call to retreive the posts that are associated with the search
        fetchPosts(ajax_data, succesfullLoad);
      }
    });
  }

  /**
   * formatTerms - function to format the terms used in the search
   * @param  {array} terms array of terms from the input field
   * @return {string}       String with posibile tags
   */
  function formatTerms(terms) {
    // Split on space
    // create a array of space seperated items.
    var new_terms = [];

    new_terms.push(terms);

    for(var i = 0; i < terms.length; i++){
      new_terms.push(terms[i]);

      for(var j = i + 1; j < terms.length; j++){
        new_terms.push(terms[i] + '-' + terms[j]);
        new_terms.push(terms[i] + ' ' + terms[j]);
      }
    }
    // map every item with each other to format terms
    console.log(new_terms.join());
    return new_terms.join();
  }

  function succesfullLoad(data) {
    data = JSON.parse(data);
    if(data.have_posts){
        console.log(data.html);
      $('section.overview .list-items').html(data.html);
      // recheck for outgoing links after the ajax call
      block_external_links();
    } else {
      $('.list-items').html('<h2>Geen resultaten gevonden.</h2><p>Deze zoekopdracht leverde niets op. Probeer een andere (combinaties van) zoektermen of categorieen.</p>');
    }

    $('#loading').fadeOut(1000);
    setTimeout(function(){
      $('#loading').remove();
    }, 1000);



  }
}(jQuery));
